export default "__VITE_ASSET__CwiOyfGX__"